import React from "react";
import { useT } from "@/i18n/LanguageContext";
import SectionHeading from "@/components/SectionHeading";
import Disclaimer from "@/components/Disclaimer";
import { Building2, ExternalLink, FileSearch, BookOpen, Phone, FileText, Scale, AlertCircle } from "lucide-react";

const Recovery = () => {
  const { t, lang } = useT();
  const icons = [FileSearch, BookOpen, Phone, AlertCircle, Building2, Scale, FileText];
  return (
    <div className="mx-auto max-w-5xl px-4 md:px-8 py-16 md:py-24" data-testid="recovery-page">
      <SectionHeading eyebrow="Path to Resolution" title={t.recovery.title} subtitle={t.recovery.subtitle} />

      <div className="mt-14 space-y-5">
        {t.recovery.steps.map((s, i) => {
          const Icon = icons[i] || FileText;
          return (
            <div key={i} className="surface-card p-6 md:p-7 flex items-start gap-5" data-testid={`rec-step-${i + 1}`}>
              <div className="flex-shrink-0 h-12 w-12 rounded-lg bg-[#D4AF37]/10 ring-1 ring-[#D4AF37]/30 grid place-items-center">
                <Icon className="h-5 w-5 text-[#D4AF37]" />
              </div>
              <div>
                <div className="font-mono-alt text-xs text-[#D4AF37]">STEP {String(i + 1).padStart(2, "0")}</div>
                <div className={`mt-1 font-display text-xl font-bold ${lang === "hi" ? "lang-hi" : ""}`}>{s.title}</div>
                <div className={`mt-2 text-sm text-white/70 leading-relaxed ${lang === "hi" ? "lang-hi" : ""}`}>{s.desc}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-16">
        <SectionHeading title={t.official.title} subtitle={t.official.subtitle} />
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {t.official.items.map((it, i) => (
            <a key={it.url} href={it.url} target="_blank" rel="noopener noreferrer" className="surface-card p-6 group" data-testid={`rec-portal-${i}`}>
              <div className="flex items-start justify-between">
                <div className="font-display text-lg font-bold">{it.title}</div>
                <ExternalLink className="h-4 w-4 text-white/40 group-hover:text-[#D4AF37] transition-colors" />
              </div>
              <div className="mt-2 text-sm text-white/65 leading-relaxed">{it.desc}</div>
              <div className="mt-3 font-mono-alt text-xs text-[#D4AF37]/80 truncate">{it.url}</div>
            </a>
          ))}
        </div>
      </div>

      <div className="mt-14">
        <Disclaimer text={t.recovery.disclaimer} variant="alert" />
      </div>
    </div>
  );
};

export default Recovery;
